import React from 'react';
import { Link } from 'react-router-dom';
import { Footer } from '../components/Footer';
import { Users, Target, Award, TrendingUp, Linkedin, ExternalLink } from 'lucide-react';
export function AboutPage() {
  const leadership = [{
    name: 'Darshit Kothari',
    role: 'CEO & Founder',
    initials: 'DK',
    linkedin: 'https://www.linkedin.com/in/darshitkothari',
    bio: 'Serial entrepreneur with 15+ years in PropTech. Previously founded two successful real estate startups. MBA from IIM Ahmedabad. Passionate about democratizing property ownership in India.'
  }, {
    name: 'Roshan Shah',
    role: 'CTO & Advisor',
    initials: 'RS',
    linkedin: 'https://www.linkedin.com/in/roshanshah',
    bio: 'Technology leader with expertise in building scalable platforms. Former VP Engineering at leading fintech unicorn. B.Tech from IIT Bombay. Specializes in blockchain and secure transaction systems.'
  }, {
    name: 'Kuleep Tiwari',
    role: 'COO',
    initials: 'KT',
    linkedin: 'https://www.linkedin.com/in/kuleeptiwari',
    bio: 'Operations expert with 12+ years in real estate and logistics. Previously COO at major property management firm. CA and MBA. Drives operational excellence and regulatory compliance.'
  }];
  const advisors = [{
    name: 'Dr. Anita Deshmukh',
    role: 'Legal Advisor',
    initials: 'AD',
    linkedin: 'https://www.linkedin.com/in/anitadeshmukh',
    bio: 'Senior Advocate with 25+ years specializing in property law. Former Additional Solicitor General. Advises on RERA compliance and legal framework. LLM from Harvard Law School.'
  }, {
    name: 'Vikram Malhotra',
    role: 'Real Estate Advisor',
    initials: 'VM',
    linkedin: 'https://www.linkedin.com/in/vikrammalhotra',
    bio: 'Real estate veteran with 30+ years in property development. Former MD of leading real estate group. Provides strategic guidance on market expansion and developer partnerships.'
  }];
  const board = [{
    name: 'Rajesh Mehta',
    role: 'Board Member & Investor',
    initials: 'RM',
    linkedin: 'https://www.linkedin.com/in/rajeshmehta',
    bio: 'Angel investor and board member of multiple PropTech startups. Former CFO of major real estate fund. CA and CFA. Brings financial expertise and investor relations experience.'
  }, {
    name: 'Sunita Krishnan',
    role: 'Independent Director',
    initials: 'SK',
    linkedin: 'https://www.linkedin.com/in/sunitakrishnan',
    bio: 'Independent director with governance expertise. Former bureaucrat with Ministry of Housing and Urban Affairs. Ensures regulatory compliance and ethical practices. IAS (Retd).'
  }];
  return <div className="min-h-screen bg-[#f5f5f7] font-sans text-[#1f2933] flex flex-col" data-id="element-1153">
      <header className="bg-white border-b border-gray-300 py-4 px-6 md:px-12" data-id="element-1154">
        <Link to="/" className="flex items-center gap-2" data-id="element-1155">
          <div className="w-8 h-8 bg-[#1f2933] rounded-sm" data-id="element-1156"></div>
          <span className="font-bold text-xl tracking-tight" data-id="element-1157">
            Citiplots.com
          </span>
        </Link>
      </header>

      <main className="flex-1 max-w-5xl mx-auto px-6 py-12" data-id="element-1158">
        <h1 className="text-4xl font-bold mb-4" data-id="element-1159">About Citiplots</h1>
        <p className="text-lg text-gray-500 mb-12 font-mono" data-id="element-1160">
          India's first direct plot transaction platform
        </p>

        <div className="space-y-12" data-id="element-1161">
          {/* Mission */}
          <section className="bg-white border border-gray-300 p-8" data-id="element-1162">
            <h2 className="text-2xl font-bold mb-4" data-id="element-1163">Our Mission</h2>
            <p className="text-gray-700 leading-relaxed mb-4" data-id="element-1164">
              Citiplots is revolutionizing India's real estate market by
              eliminating intermediaries and bringing transparency to plot
              transactions. We connect buyers directly with sellers, government
              authorities, and developers through a secure, verified platform.
            </p>
            <p className="text-gray-700 leading-relaxed" data-id="element-1165">
              Our mission is to make land ownership accessible, transparent, and
              secure for every Indian, whether they're in Mumbai or Melbourne.
            </p>
          </section>

          {/* Values */}
          <section className="bg-white border border-gray-300 p-8" data-id="element-1166">
            <h2 className="text-2xl font-bold mb-6" data-id="element-1167">Our Values</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-1168">
              <div className="p-4 border border-gray-200 bg-gray-50" data-id="element-1169">
                <Target className="w-8 h-8 text-[#1f2933] mb-3" data-id="element-1170" />
                <h3 className="font-bold mb-2" data-id="element-1171">Transparency</h3>
                <p className="text-sm text-gray-600" data-id="element-1172">
                  Every document, every price, every detail is verified and
                  visible. No hidden costs, no surprises.
                </p>
              </div>
              <div className="p-4 border border-gray-200 bg-gray-50" data-id="element-1173">
                <Award className="w-8 h-8 text-[#1f2933] mb-3" data-id="element-1174" />
                <h3 className="font-bold mb-2" data-id="element-1175">Trust</h3>
                <p className="text-sm text-gray-600" data-id="element-1176">
                  We verify every listing, every seller, and every document
                  through our rigorous compliance process.
                </p>
              </div>
              <div className="p-4 border border-gray-200 bg-gray-50" data-id="element-1177">
                <Users className="w-8 h-8 text-[#1f2933] mb-3" data-id="element-1178" />
                <h3 className="font-bold mb-2" data-id="element-1179">Direct Access</h3>
                <p className="text-sm text-gray-600" data-id="element-1180">
                  Connect directly with property owners, cutting out middlemen
                  and reducing transaction costs by 40%.
                </p>
              </div>
              <div className="p-4 border border-gray-200 bg-gray-50" data-id="element-1181">
                <TrendingUp className="w-8 h-8 text-[#1f2933] mb-3" data-id="element-1182" />
                <h3 className="font-bold mb-2" data-id="element-1183">Innovation</h3>
                <p className="text-sm text-gray-600" data-id="element-1184">
                  Leveraging technology to simplify complex real estate
                  processes and make them accessible to everyone.
                </p>
              </div>
            </div>
          </section>

          {/* Story */}
          <section className="bg-white border border-gray-300 p-8" data-id="element-1185">
            <h2 className="text-2xl font-bold mb-4" data-id="element-1186">Our Story</h2>
            <div className="space-y-4 text-gray-700 leading-relaxed" data-id="element-1187">
              <p data-id="element-1188">
                Founded in 2023, Citiplots emerged from a simple frustration:
                buying land in India shouldn't require navigating a maze of
                brokers, unclear documentation, and hidden fees.
              </p>
              <p data-id="element-1189">
                Our founders, having experienced the pain of plot transactions
                firsthand, envisioned a platform where buyers and sellers could
                connect directly, with complete transparency and
                government-verified documentation.
              </p>
              <p data-id="element-1190">
                Today, we're proud to serve thousands of users across India,
                facilitating direct transactions worth over ₹500 crores
                annually. We've partnered with state governments for auction
                listings and work with RERA-registered developers to ensure
                every listing meets the highest standards.
              </p>
            </div>
          </section>

          {/* Stats */}
          <section className="bg-white border border-gray-300 p-8" data-id="element-1191">
            <h2 className="text-2xl font-bold mb-6" data-id="element-1192">By The Numbers</h2>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6" data-id="element-1193">
              <div className="text-center p-4 border border-gray-200" data-id="element-1194">
                <div className="text-3xl font-bold text-[#1f2933] mb-1" data-id="element-1195">
                  10,000+
                </div>
                <div className="text-xs text-gray-500 font-mono" data-id="element-1196">
                  Verified Listings
                </div>
              </div>
              <div className="text-center p-4 border border-gray-200" data-id="element-1197">
                <div className="text-3xl font-bold text-[#1f2933] mb-1" data-id="element-1198">
                  50,000+
                </div>
                <div className="text-xs text-gray-500 font-mono" data-id="element-1199">
                  Active Users
                </div>
              </div>
              <div className="text-center p-4 border border-gray-200" data-id="element-1200">
                <div className="text-3xl font-bold text-[#1f2933] mb-1" data-id="element-1201">
                  ₹500Cr+
                </div>
                <div className="text-xs text-gray-500 font-mono" data-id="element-1202">
                  Transactions
                </div>
              </div>
              <div className="text-center p-4 border border-gray-200" data-id="element-1203">
                <div className="text-3xl font-bold text-[#1f2933] mb-1" data-id="element-1204">15</div>
                <div className="text-xs text-gray-500 font-mono" data-id="element-1205">
                  States Covered
                </div>
              </div>
            </div>
          </section>

          {/* Leadership Team */}
          <section className="bg-white border border-gray-300 p-8" data-id="element-1206">
            <h2 className="text-2xl font-bold mb-4" data-id="element-1207">Leadership Team</h2>
            <p className="text-gray-600 mb-8" data-id="element-1208">
              Our team brings together expertise in real estate, technology, and
              legal compliance.
            </p>
            <div className="space-y-8" data-id="element-1209">
              {leadership.map(member => <div key={member.name} className="flex gap-6 p-6 border border-gray-200 bg-gray-50" data-id="element-1210">
                  <div className="w-24 h-24 bg-gray-200 rounded-full flex items-center justify-center font-bold text-2xl shrink-0" data-id="element-1211">
                    {member.initials}
                  </div>
                  <div className="flex-1" data-id="element-1212">
                    <div className="flex items-center gap-3 mb-2" data-id="element-1213">
                      <h3 className="font-bold text-lg" data-id="element-1214">{member.name}</h3>
                      <a href={member.linkedin} target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-800" data-id="element-1215">
                        <Linkedin className="w-5 h-5" data-id="element-1216" />
                      </a>
                    </div>
                    <p className="text-sm font-bold text-gray-600 mb-3" data-id="element-1217">
                      {member.role}
                    </p>
                    <p className="text-sm text-gray-700 leading-relaxed" data-id="element-1218">
                      {member.bio}
                    </p>
                  </div>
                </div>)}
            </div>
          </section>

          {/* Advisors */}
          <section className="bg-white border border-gray-300 p-8" data-id="element-1219">
            <h2 className="text-2xl font-bold mb-4" data-id="element-1220">Advisory Board</h2>
            <p className="text-gray-600 mb-8" data-id="element-1221">
              Industry experts providing strategic guidance and domain
              expertise.
            </p>
            <div className="space-y-8" data-id="element-1222">
              {advisors.map(advisor => <div key={advisor.name} className="flex gap-6 p-6 border border-gray-200 bg-gray-50" data-id="element-1223">
                  <div className="w-24 h-24 bg-gray-200 rounded-full flex items-center justify-center font-bold text-2xl shrink-0" data-id="element-1224">
                    {advisor.initials}
                  </div>
                  <div className="flex-1" data-id="element-1225">
                    <div className="flex items-center gap-3 mb-2" data-id="element-1226">
                      <h3 className="font-bold text-lg" data-id="element-1227">{advisor.name}</h3>
                      <a href={advisor.linkedin} target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-800" data-id="element-1228">
                        <Linkedin className="w-5 h-5" data-id="element-1229" />
                      </a>
                    </div>
                    <p className="text-sm font-bold text-gray-600 mb-3" data-id="element-1230">
                      {advisor.role}
                    </p>
                    <p className="text-sm text-gray-700 leading-relaxed" data-id="element-1231">
                      {advisor.bio}
                    </p>
                  </div>
                </div>)}
            </div>
          </section>

          {/* Board of Directors */}
          <section className="bg-white border border-gray-300 p-8" data-id="element-1232">
            <h2 className="text-2xl font-bold mb-4" data-id="element-1233">Board of Directors</h2>
            <p className="text-gray-600 mb-8" data-id="element-1234">
              Experienced directors ensuring governance, compliance, and
              strategic oversight.
            </p>
            <div className="space-y-8" data-id="element-1235">
              {board.map(member => <div key={member.name} className="flex gap-6 p-6 border border-gray-200 bg-gray-50" data-id="element-1236">
                  <div className="w-24 h-24 bg-gray-200 rounded-full flex items-center justify-center font-bold text-2xl shrink-0" data-id="element-1237">
                    {member.initials}
                  </div>
                  <div className="flex-1" data-id="element-1238">
                    <div className="flex items-center gap-3 mb-2" data-id="element-1239">
                      <h3 className="font-bold text-lg" data-id="element-1240">{member.name}</h3>
                      <a href={member.linkedin} target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-800" data-id="element-1241">
                        <Linkedin className="w-5 h-5" data-id="element-1242" />
                      </a>
                    </div>
                    <p className="text-sm font-bold text-gray-600 mb-3" data-id="element-1243">
                      {member.role}
                    </p>
                    <p className="text-sm text-gray-700 leading-relaxed" data-id="element-1244">
                      {member.bio}
                    </p>
                  </div>
                </div>)}
            </div>
          </section>
        </div>
      </main>

      <Footer data-id="element-1245" />
    </div>;
}